var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"creator_detail_wrap"},[_c('member-detail-component',{attrs:{"member-type":'myProfile'}}),_c('my-profile-tabs'),_c('router-view')],1),_c('curation-history-modal',{attrs:{"memberKey":_vm.UserInfo.mb_no}}),_c('share-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }